<template>
  <layout>
    <v-layout row wrap>
      <v-flex xs12>
        <page-title header="Solicitação de Câmbio" subheader="Preencha as informações abaixo" />
      </v-flex>
      <v-flex xs12 offset-md3 md6 pt-3>
        <calculator />
      </v-flex>
    </v-layout>
  </layout>
</template>
<script>
import HomeLayout from "./layouts/HomeLayout"
import USBBRLCalculator from "./USDBRLCalculator"
import Title from "./components/Title"

export default {
  name: 'ExchangeRequest',
  components: { layout: HomeLayout, calculator: USBBRLCalculator, 'page-title': Title },
  data() {
    return {
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/ExchangeRequest.vue